import React from "react";
import Main from "./components/Main";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import "./theme/DRGHISTheme.css";
import {createTheme, ThemeProvider} from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
const theme = createTheme({
    palette: {
        mode: "light",
        primary: {
            main: "#2563EB",
        },
        secondary: {
            main: "#00D4FF",
        },
        background: {
            default: "#eef5fb",
            paper: "#ffffff",
        },
        success: {
            main: "#22C55E",
        },
        warning: {
            main: "#F59E0B",
        },
        error: {
            main: "#EF4444",
        },
    },
    shape: {
        borderRadius: 12,
    },
    typography: {
        fontFamily: [
            '"Plus Jakarta Sans"',
            '"Inter"',
            '-apple-system',
            'BlinkMacSystemFont',
            '"Segoe UI"',
            'sans-serif',
        ].join(','),
        h5: {
            fontWeight: 700,
        },
        button: {
            textTransform: "none",
            fontWeight: 600,
        },
    },
});
function App() {
    return (
        <ThemeProvider theme={theme}>

            <CssBaseline/>

            <div className="App">

                <div className="container-fluid">

                    <Main/>

                </div>

            </div>

        </ThemeProvider>
    );
}
export default App;